import { render, staticRenderFns } from "./Devize_inchise_fara_factura_list.vue?vue&type=template&id=54db0bf4&scoped=true"
import script from "./Devize_inchise_fara_factura_list.vue?vue&type=script&lang=js"
export * from "./Devize_inchise_fara_factura_list.vue?vue&type=script&lang=js"
import style0 from "./Devize_inchise_fara_factura_list.vue?vue&type=style&index=0&id=54db0bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db0bf4",
  null
  
)

export default component.exports